import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { RegisterForm } from '../components/Auth/RegisterForm';

export const RegisterPage: React.FC = () => {
  return (
    <Layout showSidebar={false}>
      <RegisterForm />
    </Layout>
  );
};
